
import axios from "axios";
import cn from "classnames";

import styles from "./Tracking.module.scss";
import Table from "../../components/common/Table";
import ReactTooltip from "react-tooltip";
import Master from "screen/Master";
import GoogleMapMarker from "components/googlemap/GoogleMapMakerTracking";
import Search from "../../components/common/Search";
import Button from "@material-ui/core/Button";
import { getRequest } from "services/axiosBaseClient";
import Geocode from "react-geocode";
import LocalStorageService from "services/tokenlocalstorage.service";
import React, {
  useState,
  useEffect,
  useRef,
  ComMapponent,
  useCallback,
} from "react";
import { Link } from "react-router-dom";
import { getRequestInAssets } from "services/axiosAssetsBaseClient";
import moment from "moment";

export default function Tracking(props) {
  const [headerFilter, setHeaderFilter] = useState(true);
  function TrackingView(props) {
    const columns = React.useMemo(() => [
      {
        Header: "Total No.",
        accessor: "totalNo",
      },
      {
        Header: "Battery Serial No.",
        accessor: "batterySerialNumber",
      },
      {
        Header: "Address",
        accessor: "address",
        Cell: (row) => {
          return (
            <>
              <div data-for="main" data-tip={row.row.original.address}>
                {row.row.original.address.length > 30 ? row.row.original.address.slice(0, 30) + "..." : row.row.original.address}
              </div>
              <ReactTooltip id="main" type="light" />
            </>
          );
        },
      },
      {
        Header: "Start Time",
        accessor: "startTime",
      },
      {
        Header: "End Time",
        accessor: "endtime",
      },
      {
        Header: "Miles",
        accessor: "miles",
      },
      {
        Header: "Duration",
        accessor: "duration",
      },
    ]);

    const filterInitialValue = {
      siteId: "",
      chargerId: "",
      state: "",
      city: "",
      zoneId: "",
      time: "HOUR_24",
    };
    const [sitesList, setSitesList] = useState([]);
    const [chargerList, setChargerList] = useState([]);
    const [userRole, setUserRole] = useState("");
    const [alert, setAlert] = useState([]);
    const [filter, setFilter] = useState(filterInitialValue);
    const [selectTimeValue, setSelectTimeValue] = useState("HOUR_24");
    const [selectTime, setSelectTime] = useState("HOUR_24");

    const [data, setData] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [addressTest, setAddressTest] = useState([]);
    const [Coords, setCoords] = useState([]);
    const refOpen = useRef(open);
    const [loading, setLoading] = useState(false);
    const [addressBar, setAddressBar] = useState("");

    const [totalMiles, setTotalMiles] = useState(0);
    const [totalHours, setTotalHours] = useState(0);
    const [totalMin, setTotalMin] = useState(0);
    const [noRecord, setNoRecord] = useState(false);
    // const addressData = useCallback(async (latitude,longitude)=>{
    const addressData = async (latitude, longitude) => {
      return await Geocode.fromLatLng(
        latitude,
        longitude,
        process.env.REACT_APP_GOOGLE_API_KEY
      ).then(
        (response) => {
          return response.results[0].formatted_address;
        },
        (error) => {
          console.error(error);
          return "";
        }
      );
    };

    function useOutsideAlerter(ref, ref1) {
      useEffect(() => {
        function handleClickOutside(event) {
          if (ref.current && !ref.current.contains(event.target)) {
            setOpen(false);
            refOpen.current = false;
          } else {
            if (
              refOpen.current &&
              ref1.current &&
              !ref1.current.contains(event.target)
            ) {
              refOpen.current = false;
              setOpen(false);
            } else {
              setOpen(true);
              refOpen.current = true;
            }
          }
        }

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          // Unbind the event listener on clean up
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [ref, ref1]);
    }

    const wrapperRef = useRef(null);
    const wrapperRefInside = useRef(null);

    useOutsideAlerter(wrapperRef, wrapperRefInside);
    const handleChange = (event) => {
      const { name, value } = event.target;
      setFilter({ ...filter, [name]: value });
      if (event.target.name == "time") {
        setSelectTime(event.target.value);
      }
      if (event.target.name == "siteId") {
        setFilter({ ...filter, [name]: value, chargerId: "" });
        // getChargers(event.target.value);
      }
    };
    const handleClick = () => {
      if (open) {
        setSelectTimeValue(selectTime);
        // getEnergyGraph(filter);
        // getSwappingGraph(filter);
        // getFaultGraph(filter);
        // getBatteryCountAndStatus(filter);
        setOpen(false);
      } else {
        setOpen(true);
      }
    };
    var Coords1 = [
      {
        lat: 28.59565,
        lng: 77.34394,
        // "time": "2022-06-22 06:43:42.215607"
      },
      {
        lat: 28.461448,
        lng: 78.023107,
        // "time": "2022-06-22 06:43:42.215607"
      },
      {
        lat: 28.59565,
        lng: 75.34394,
        // "time": "2022-06-22 06:43:42.215607"
      },
      {
        lat: 29.461448,
        lng: 78.023107,
        // "time": "2022-06-22 06:43:42.215607"
      },

      {
        lat: 30.461448,
        lng: 79.023107,
        // "time": "2022-06-22 06:43:42.215607"
      },
      {
        lat: 31.461448,
        lng: 80.023107,
        // "time": "2022-06-22 06:43:42.215607"
      },
    ];
    // setCoords(Coords1);
    const trackingData = async (filter, page, pageSize, tigger, batterySerial) => {
      const headerFilterObj = JSON.parse(
        LocalStorageService.get("headerFilter")
      );
      setNoRecord(false);
      setLoading(true);
      setCoords([]);
      setData([]);
      setTotalHours(0);
      setTotalMin(0);
      setTotalMiles(0);
      if (batterySerial !== undefined && batterySerial != 0) {
        batterySerial = batterySerial.trim();
      }
      var arr1 = [];
      var arr2 = [];
      var response;
      var query =
        (headerFilterObj?.stateId === undefined ||
          headerFilterObj?.stateId === ""
          ? ""
          : "&stateId=" + headerFilterObj.stateId) +
        (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
          ? ""
          : "&cityId=" + headerFilterObj.cityId) +
        (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
          ? ""
          : "&zoneId=" + headerFilterObj.zoneId);

      await getRequest(`track?batterySerialNumber=${batterySerial ? batterySerial : ""}` + query)
        .then((res) => {
          if (res && res?.data && res?.data?.length >= 1) {
            response = res.data;
          }
          else {
            setNoRecord(true);
          }
        })
        .catch((err) => {
          console.error("Error", err);
          setCoords([]);
          setData([]);
          if (!batterySerial) {
            setNoRecord(false);
          }
          else {
            setNoRecord(true);
          }
          setLoading(true);
        });
      var i = 1;
      var milesTotal = 0;
      var hoursTotal = 0;
      var minTotal = 0;
      let durationOne = moment.duration(0, 'months');
      if (response) {
        response.reverse();
        for (const item of response) {
          if (item.latitude && item.longitude) {
            var address = await addressData(item.latitude, item.longitude);
            var duration = "-";
            if (
              !(
                item.startTime === null ||
                item.startTime === undefined ||
                item.endtime === null ||
                item.endtime === undefined
              )
            ) {
              var ms = moment(item.endtime).diff(moment(item.startTime * 1000));
              var d = moment.duration(ms);
              durationOne.add(d);
              duration =
                (parseInt(d.asHours()) > 0 ? (parseInt(d.asHours()) + "h ") : "") +
                ((parseInt(d.asMinutes()) % 60) > 0 ? ((parseInt(d.asMinutes()) % 60) + "min") : "");
            }
            if (duration === '')
              duration = "-"
            if (item.miles) {
              item.miles = parseFloat(item.miles).toFixed(1);
              milesTotal = milesTotal + parseFloat(item.miles);
            }
            var var1 = {
              totalNo: i,
              batterySerialNumber: item.batterySerialNumber,
              address: address,
              startTime: item.startTime
                ? moment(item.startTime * 1000).format("DD-MM-YYYY HH:mm:ss")
                : "-",
              endtime: item.endtime
                ? moment(item.endtime).format("DD-MM-YYYY HH:mm:ss")
                : "-",
              miles: item.miles ? item.miles : "-",
              duration: duration,
            };
            var var2 = {
              lat: parseFloat(item.latitude),
              lng: parseFloat(item.longitude),
              id: i,
            };
            i++;
            arr2.push(var2);
            arr1.push(var1);
          }
        }
        hoursTotal = hoursTotal + parseInt(durationOne.asHours());
        minTotal = minTotal + ((parseInt(durationOne.asMinutes()) % 60));
        setTotalHours(hoursTotal);
        setTotalMin(minTotal);
        setTotalMiles((Number(milesTotal) === milesTotal && milesTotal % 1 === 0) ? milesTotal : milesTotal.toFixed(1));
        setCoords(arr2);
        setData(arr1);
        if (arr1.length == 0 && arr2.length == 0) {
          setNoRecord(true);
        }
      }
      setLoading(false);
    };

    const getTime = (val) => {
      const endTime = Math.round(new Date().getTime() / 1000);
      const startTime = endTime - val * 3600;

      //filter.endDate = endTime;
      //filter.startDate = startTime;
    };

    useEffect(() => {
      const headerFilterObj = JSON.parse(
        LocalStorageService.get("headerFilter")
      );
      if (headerFilterObj !== null) {
        filter.state = headerFilterObj.state;
        filter.city = headerFilterObj.city;
        filter.zoneId = headerFilterObj.zoneId;
      }
      trackingData()
      return
    }, [props.headerFilter]);
    return (
      <>
        <h2 id="Tracking_Heading" className={cn(styles.medium_title, styles.medium_title_layout)}>
          {userRole.toLowerCase() === "admin" ? "Tracking" : "Tracking"}
        </h2>
        <div
        id="Tracking_Container"
          className={cn(styles.card_list_block, styles.card_list_block_layout)}
        >
          <div id="Tracking_MapContainer" className={cn(styles.map_card)}>
            <div id="Tracking_MapSearch_Block" className={cn(styles.flex6, styles.flex6_layout)}>
              <div id="Tracking_MapSearch_Layout" className={cn(styles.flex7, styles.flex7_layout)}>
                <div id="Tracking_MapSearch_Layout1" className={cn(styles.flex7_item)}>
                  <Search
                    name="batterySerial"
                    id="batterySerial"
                    onSearch={trackingData}
                    placeholder="Search"
                    filter={filter}
                  />
                </div>
                <div className={cn(styles.flex7_spacer)} />

              </div>
            </div>
            <div
            id="Tracking_MapStatus_block"
              className={cn(
                styles.status_block_map,
                styles.status_block_layout_map
              )}
            >
              {!loading && noRecord && (<div className={cn(styles.no_data_found_container)}>
                <img
                  src={require("assets/Search_No_data_Found.svg").default}
                  height={"60px"}
                  width={"60px"}
                ></img>
                <h5 className={cn(styles.no_data_found_label)}>
                  No Data Found
                </h5>
              </div>)}

              {!loading && !noRecord && (
                <GoogleMapMarker
                  chartData={Coords}
                // Coords={Coords}
                />
              )}
            </div>
          </div>

          <div
          id="Tracking_Table"
            style={{
              borderRadius: "7px",
              backgroundColor: "#fff",
              marginTop: "20px",
              "box-shadow": "rgb(35 41 122 / 25%) 0px 3px 8px 2px",
            }}
          >
            <div
            id="Tracking_Table_block"
              className={cn(styles.flex2, styles.flex2_layout, styles.pdt20)}
            >
              <div id="Tracking_Table_title_block" className={cn(styles.flex2_item)}>
                <div id="Tracking_Table_title_block1" className={cn(styles.block1, styles.block1_layout)}>
                  <img
                  id="Tracking_Table_title_img"
                    src={require("assets/batteryTrackingIcon.svg").default}
                    alt="Rectangle 16663"
                    className={cn(styles.box1, styles.box1_layout)}
                  />
                </div>
              </div>
              <div className={cn(styles.flex2_spacer)} />
              <div id="Tracking_Table_title_text" className={cn(styles.flex2_item1)}>
                <div className={cn(styles.block2, styles.block2_layout)}>
                  <h2
                  id="Tracking_Table_title"
                    className={cn(
                      styles.medium_title,
                      styles.medium_title_layout
                    )}
                  >
                    <p> {"Battery Live Tracking"}</p>
                    <p>{totalHours}HR {totalMin}MIN</p>
                  </h2>
                  <p>{totalMiles} Miles</p>
                </div>
              </div>
            </div>
            <div className={cn(styles.flex2, styles.flex2_layout)}>
              <Table columns={columns} data={data} />
            </div>
          </div>
        </div>
      </>
    );
  }
  return (

    <>
      <Master opts={props} screen={TrackingView} showStatus={false}
        headerFilter={headerFilter}
        setHeaderFilter={setHeaderFilter}
      />
    </>
  );
}

Tracking.inStorybook = true;
